import { parseDateInput, toDateInputValue } from './ageCalculatorEngine.js';

/**
 * @param {string} [at]
 */
export function defaultAgeAtParam(at) {
  return at || toDateInputValue(new Date());
}

/**
 * @param {string} pathname e.g. /tools/general/age-calculator
 * @param {{ dob?: string, ageAt?: string, compareDob?: string, diffEnabled?: boolean }} state
 */
export function buildAgeCalculatorSharePath(pathname, state) {
  const params = new URLSearchParams();
  const dob = state.dob?.trim();
  const ageAt = state.ageAt?.trim();
  const compareDob = state.compareDob?.trim();
  const today = toDateInputValue(new Date());

  if (dob && parseDateInput(dob)) params.set("dob", dob);
  if (ageAt && parseDateInput(ageAt) && ageAt !== today) params.set("at", ageAt);
  if (state.diffEnabled && compareDob && parseDateInput(compareDob)) {
    params.set("compare", compareDob);
    params.set("diff", "1");
  }

  const qs = params.toString();
  return qs ? `${pathname}?${qs}` : pathname;
}

/**
 * @param {string} origin e.g. https://sohozkaj.com
 * @param {string} pathname
 * @param {Parameters<typeof buildAgeCalculatorSharePath>[1]} state
 */
export function buildAgeCalculatorShareUrl(origin, pathname, state) {
  return `${origin}${buildAgeCalculatorSharePath(pathname, state)}`;
}

/**
 * @param {URLSearchParams | string} input
 */
export function parseAgeCalculatorShareParams(input) {
  const params = typeof input === "string" ? new URLSearchParams(input) : input;
  const dobRaw = params.get("dob") ?? "";
  const atRaw = params.get("at") ?? "";
  const compareRaw = params.get("compare") ?? "";
  const diffFlag = params.get("diff") === "1";

  const dob = parseDateInput(dobRaw) ? dobRaw : "";
  const ageAt = parseDateInput(atRaw) ? atRaw : defaultAgeAtParam();
  const compareDob = parseDateInput(compareRaw) ? compareRaw : "";
  const diffEnabled = diffFlag || Boolean(compareDob);

  return { dob, ageAt, compareDob, diffEnabled };
}
